module.exports = __webpack_public_path__ + "img/sections.b7739113.jpg";